/**
 * Der Supabase-Client — ausschließlich für die Anmeldung.
 *
 * Er redet mit GoTrue, nie mit der Datenbank. Fachdaten kommen ohne Ausnahme
 * über `lib/api.ts` von der eigenen API: Sonst existierte jede Sichtbarkeits-
 * regel zweimal — einmal in `permissions/` und einmal als RLS-Politik, die
 * niemand mitpflegt (ARCHITECTURE.md).
 *
 * Was er liefert, ist genau eins: ein gültiges Zugangstoken. Das hängt
 * `lib/api.ts` als `Authorization: Bearer` an jede Anfrage, und die API prüft
 * es gegen die JWKS von Supabase.
 */

import { createClient } from '@supabase/supabase-js'

/** Fehlt einer der beiden Werte, ist die Anmeldung unmöglich. Das darf beim
 * Start auffallen und nicht erst, wenn jemand auf „Anmelden“ drückt. */
function required(name: string, value: string | undefined): string {
  if (value === undefined || value === '') {
    throw new Error(`${name} fehlt. Ohne sie ist keine Anmeldung möglich (.env.local).`)
  }
  return value
}

export const supabase = createClient(
  required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // Die Anwendung hat keine OAuth-Rückläufe; ein Token im URL-Fragment wäre
      // hier immer ein Fremdkörper.
      detectSessionInUrl: false,
    },
  },
)
